import React from 'react';
import { Box, Typography } from '@mui/material';
import { ChangesTable, ChangesTableProps } from './ChangesTable';
import { CHANGES_TABLE_SECTION_ID } from '../utils/changeTableFocus';

const TITLE = 'Mudanças Legislativas Recentes';
const SUBTITLE = 'Últimas alterações detectadas no sistema';

export interface MudancasLegislativasTableSectionProps extends ChangesTableProps {
  /** Título da seção. Omitir para usar o padrão. */
  title?: string;
  /** Subtítulo. Omitir para usar o padrão. */
  subtitle?: string;
  /** Ocultar título e subtítulo (só renderiza a tabela). */
  hideHeader?: boolean;
}

/**
 * Seção reutilizável: título + subtítulo + ChangesTable.
 * Usado no Dashboard e na aba Mudanças para garantir a mesma tabela e UX.
 */
export function MudancasLegislativasTableSection({
  title = TITLE,
  subtitle = SUBTITLE,
  hideHeader = false,
  ...tableProps
}: MudancasLegislativasTableSectionProps) {
  return (
    <Box id={CHANGES_TABLE_SECTION_ID}>
      {!hideHeader && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        </Box>
      )}
      <ChangesTable {...tableProps} />
    </Box>
  );
}
